import { useTranslation } from "next-i18next"
import TestsMainButton from "./TestsMainButton"
import styles from "./CTA.module.scss"

export default function CTA({ buttonText, buttonAction }) {
  const { t } = useTranslation("common")
  return (
    <div className={styles.Wrapper}>
      <div className={styles.Card}>
        <div className={styles.Title}>{t("HOME_INSTRUCTIONS")}</div>
        <TestsMainButton text={buttonText} action={buttonAction} />
      </div>
    </div>
  )
}
